import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "../Dashboard/Invoice/Invoice.css";
import { useLocation } from 'react-router-dom';
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import ATMDepositTable from "../Dashboard/Invoice/ATMDepositTable";
import { useToastHandler } from "../../../common/ToastHandler";
function AddAtmDespoite() {
  const { user } = useContext(AuthContext);
  const { Get, Post , _Get } = useApi();
  const storeid = user.store;
  const navigate = useNavigate();
  const {handleToast} = useToastHandler()
  const today = new Date().toISOString().split("T")[0]; 

  const [activeButton, setActiveButton] = useState('/atm-invoice');

  const location = useLocation();

  useEffect(() => {
    setActiveButton(location.pathname); 
  }, [location.pathname]);

  const [isOpen, setIsOpen] = useState(false);
  const [banks, setBanks] = useState([]);

  const dropdownRef = useRef(null);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const [reloadData, setReloadData] = useState(false);
  const [formData, setFormData] = useState({
    date: "" || today,
    transaction_type: "ATM Deposit",
    bank: "",
    amount: "",
    cash_amount: "",
    cheque_amount: "",
    total_amount: "",
    note: "",
    atm_commission: "",
    income_type: null,
    bank_deposite_type: "",
    owner: null,
  });

  const makeBlank = () => {
    setFormData({
      date: "" || today,
      transaction_type: "ATM Deposit",
      bank: "",
      amount: "",
      cash_amount: "",
      cheque_amount: "",
      total_amount: "",
      note: "",
      atm_commission: "",
      income_type: null,
      bank_deposite_type: "",
      owner: null,
    });
  };

  const handleCancel = () => {
    makeBlank();

  };

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const data = await _Get("bank");
        setBanks(data);
      } catch (error) {
        console.error("Error fetching banks:", error);
        handleToast({
          type:'ERROR',
          message:"Error fetching banks:", error
        })
      }
    };
    fetchBanks();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLinkClick = (path) => {
    setIsOpen(false); 
    navigate(path); 
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.bank_deposite_type || formData.bank_deposite_type === "") {

      handleToast({
        type:'ERROR',
        message:"Please select a valid Deposite type."
      })
      return; 
    }

    if (!formData.cash_amount || formData.cash_amount <= 0) {

      handleToast({
        type:'ERROR',
        message:"Please enter a valid Cash amount."
      })
      return; 
    }

    try {
      const updatedFormData = { ...formData, store: storeid };
      await Post("transactionData", updatedFormData)
        .then((resp) => {

          handleToast({
            type:'SUCCESS',
            message:"Submission successful!"
          })
          setReloadData(!reloadData);

          makeBlank();
        })
        .catch((error) => {
          setReloadData(!reloadData);
          console.error("Error submitting form:", error);

          handleToast({
            type:'ERROR',
            message:`Submission failed:${error.message}`
          })
        });
    } catch (error) {
      setReloadData(!reloadData);

      handleToast({
        type:'ERROR',
        message:`Submission failed:${error.message}`
      })
    }
  };

  return (
    <div className="dashboard-container">
      <ToastContainer />
      <div className="d-flex justify-content-between mb-4">
      <div className="button-groups">

          <button
            className={`btn ${activeButton === '/atm-invoice' ? 'active' : ''}`}
            onClick={() => handleLinkClick('/atm-invoice')}
          >
            ATM Deposit
          </button>

          <button
            className={`btn ${activeButton === '/bank-invoice' ? 'active' : ''}`}
            onClick={() => handleLinkClick('/bank-invoice')}
          >
            Bank Deposit
          </button>

        </div>
      </div>
      <div className="formcontainer">
        <div
          className="container"
          style={{
            backgroundColor: "white",
            border: "1px solid #EBEAF2",
            boxShadow:"0px 2px 8px rgba(6, 12, 34, 0.0392157)",
            borderRadius: "40px",

          }}
        >
          <form onSubmit={handleSubmit}>

            <div className=" col-md-12 row mb-3"
            style={{
              gap: "11%",
              marginLeft:"20px"

          }}>
              <div className="col-md-3 mb-2">
                <input
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none", 
                    borderBottom: "1px solid #ccc", 
                    borderRadius: "0px", 
                    height: "52px",
                  }}
                  type="date"
                  className="form-control-borderless"
                  name="date"
                  value={formData.date || today}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-3 mb-3">
                <select
                 style={{
                    backgroundColor: "#ffffff",
                    border: "none", 
                    borderBottom: "1px solid #ccc", 
                    borderRadius: "0px", 
                    height: "52px",
                  }}
                  className="input-select"
                  id="bank_deposite_type"
                  name="bank_deposite_type"
                  value={formData.bank_deposite_type}
                  onChange={handleChange}
                >
                  <option value="">Select Cash type</option>
                  {["Business cash", "Lottery cash", "Gas cash"].map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 mb-4">
                <div className="input-group" style={{ width: "100%" , position: "relative",marginTop: "19px"}}>
                  {}

                  <input
                    type="number"

                    className="form-control-invoice"
                    name="cash_amount"
                    placeholder=""
                    value={formData.cash_amount}
                    onChange={handleChange}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9.]/g, '') 
                        .replace(/^(\d*\.?\d{0,2}).*/g, '$1') 
                        .slice(0, 12); 
                    }}
                  />
                   <label
                    htmlFor="cash_amount"
                    className="floating-label-invoice"

                  >
                    Amount
                  </label>
                </div>
              </div>

              {}
            </div>

            <div className="col-md-3 row">

              {}
            </div>

            <div className="">

              <div className="d-flex justify-content-end"  style={{ gap: "15px" }}>
                <button
                  type="button"
                  className="btn btn-contained me-2"
                  onClick={handleCancel}
                  style={{ border: " 1px solid #282e26" , borderRadius: '40px' , width: "150px", height:"38px",  fontWeight:"bold" }}
                >
                  Clear
                </button>
                <button type="submit" className="btn" style={{ color: "white", backgroundColor: '#282e26', borderRadius: '40px' , width: "150px", height:"38px" ,  fontWeight:"bold"}}>
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div
        className="container mt-5"
        style={{
          backgroundColor: "white",
           boxShadow: "0px 2px 8px rgba(6, 12, 34, 0.0392157)",
        border: "1px solid #EBEAF2"

        }}
      >
        <ATMDepositTable transaction_type="ATM Deposit" reloadData={reloadData} />
      </div>
    </div>
  );
}

export default AddAtmDespoite;